// declare function require(module: string): unknown;
//const jsUtilities = require("../../js/jsUtilities") as any;

class AjaxRequest {

    private _xhr: JQueryXHR;
    constructor(xhr: JQueryXHR) {
        this._xhr = xhr;
    }

    abort() {
        this._xhr.abort();
    }
}

export = AjaxRequest;